module.exports = __webpack_public_path__ + "img/play.047e0bbf.png";